import { extendObservable, action, computed } from "mobx";
import { camelCase } from "@ridi/object-case-converter";
import axios from "../../../libs/axios_csrf";

export default class Contacts {
  constructor(rootStore) {
    this.rootStore = rootStore;
    extendObservable(this, {
      contacts: []
    });
    this.fetch();
  }

  getParticipantsInSelection(selection) {
    return this.contacts.filter(element => selection.includes(element.id));
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BACKEND CONNECTIONS
  @action
  fetch() {
    axios
      .get("/contacts.json")
      .then(
        action(response => {
          this.contacts = camelCase(response.data, true);

          this.contacts.slice().forEach(({ name, id }) => {
            createUserSessionSubscription(id, this.updateContactOnlineState);
          });

          return response.data;
        })
      )
      .catch(
        action(error => {
          console.log(error);
          return null;
        })
      );
  }

  @action
  updateContactOnlineState = contact => {
    const { name, id, online } = contact;

    this.contacts.find(c => c.id === id).online = online;
  };

  @action
  online(online) {
    axios.patch("/users/online", { user: { online } });
  }
  // end BACKEND CONNECTIONS
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
